import Cookie from "../../../packages/Cookie";
import env from "../../../utilities/env";
import { useSafeConfigSlice } from "../config/safe-config";

export const getAuthToken = () => {
	const NODE_ENV = env("NODE_ENV");
	const isProduction = NODE_ENV === "production";
	const [id_token] = Cookie("id_token");
	const [id_token_tmnab2cqa] = Cookie("id_token_tmnab2cqa");
	const [id_token_local] = !isProduction ? Cookie("id_token_local") : [null];
	return id_token_local ?? id_token ?? id_token_tmnab2cqa;
};

export const useAuthToken = () => {
	const { NODE_ENV } = useSafeConfigSlice(["NODE_ENV"]);
	const isProduction = NODE_ENV === "production";
	const [id_token] = Cookie("id_token");
	const [id_token_tmnab2cqa] = Cookie("id_token_tmnab2cqa");
	const [id_token_local] = !isProduction ? Cookie("id_token_local") : [null];
	return id_token_local ?? id_token ?? id_token_tmnab2cqa;
};

export const getIsAuthenticated = () => !!getAuthToken();
export const useIsAuthenticated = () => !!useAuthToken();
